module.exports = __webpack_public_path__ + "img/a4e35d1558478c79cf15819080afe4dd.png";